import React from 'react';
import { LocalDiningHistoryRecord } from 'common/api/clo-history/mock-api/useLocalDiningHistory';
import { createStyles } from 'utils/createStyle';
import { colors } from 'styles/settings';
import { formatISODate } from './RecentPurchase';

export interface LocalDiningHistoryItemProps {
    item: LocalDiningHistoryRecord;
}

const style = createStyles({
    historyItem: [
        'my-3',
        {
            borderRadius: '5px',
            borderColor: colors.darkBlue,
            borderWidth: '1px',
        },
    ],
    headerDate: 'text-17px text-brand-dark pl-3 pt-2 pb-1',
    referenceNumber: 'text-12px text-dark-grey pl-3 pb-2',
    cardHeader: 'p-1',
    table: 'w-full',
    headerRow: { borderBottom: '1px solid', borderBottomColor: colors.lightGrey },
    firstHeaderText: ['text-left px-2 text-12px text-brand-dark pl-4 pb-1 font-semibold'],
    headerNumbers: [
        'text-right text-12px text-brand-dark pb-1 font-semibold px-3',
        { width: '15%', maxWidth: '15%' },
    ],
    cellText: 'text-left py-5 text-14px font-semibold pl-4 pr-3',
    cellEarnings: [
        'text-right px-3 text-14px text-success font-bold',
        { width: '15%', maxWidth: '15%' },
    ],
    cellTotal: [
        'text-right px-3 text-14px text-brand-dark font-bold',
        { width: '15%', maxWidth: '15%' },
    ],
    restaurantField: [
        'text-brand-dark font-bold',
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '15px',
        },
    ],
});

export const LocalDiningHistoryItem = (props: LocalDiningHistoryItemProps): React.ReactElement => {
    const item: LocalDiningHistoryRecord = props.item;

    return (
        <div className={style.historyItem} key={item.transactionId}>
            <div className={style.cardHeader}>
                <h4 className={style.headerDate}>{formatISODate(item.transactionDateTime)}</h4>
                <div className={style.referenceNumber}>Reference # {item.transactionId}</div>
            </div>

            <table className={style.table}>
                <thead className={style.headerRow}>
                    <tr>
                        <th className={style.firstHeaderText}>Restaurant</th>

                        <th className={style.headerNumbers}>Earnings</th>

                        <th className={style.headerNumbers}>Total</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className={style.cellText}>
                            <div className={style.restaurantField}>
                                {/* <img src="" width="58" height="36" /> */}
                                <div>{item.merchantName}</div>
                            </div>
                        </td>

                        <td className={[style.cellEarnings].join()}>
                            {item.organizationBenefitAmount}
                        </td>

                        <td className={[style.cellTotal].join()}>{item.transactionAmount}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
